"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Random = /** @class */ (function () {
    function Random() {
    }
    /**
    * Get a random integer
    *
    * @param  {number} min
    * @param  {number} max
    * @return {number}
    */
    Random.int = function (min, max) {
        if (min === void 0) { min = 1; }
        if (max === void 0) { max = 9999999; }
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    /**
    * Generate random string
    *
    * @param  {number} length
    * @param  {string} startsWith
    * @return {string}
    */
    Random.string = function (length) {
        if (length === void 0) { length = 32; }
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    };
    /**
    * Generate random id
    *
    * @param  {number} length
    * @param  {string} startsWith
    * @return {string}
    */
    Random.id = function (length, startsWith) {
        if (length === void 0) { length = 6; }
        if (startsWith === void 0) { startsWith = 'el-'; }
        return startsWith + Random.string(length);
    };
    return Random;
}());
exports.default = Random;
//# sourceMappingURL=random.js.map